(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setHeaderHeight() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--jm-header-h', h.offsetHeight + 'px');
  }

  function initHero(root) {
    if (root.dataset.jmReady) return;
    root.dataset.jmReady = '1';
    var slides = root.querySelectorAll('.jm-hero__slide');
    var dots = root.querySelectorAll('.jm-hero__dot');
    var count = root.querySelector('[data-jm-count]');
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    root.style.setProperty('--jm-interval', interval + 'ms');
    var i = 0, timer = null;
    if (slides.length < 2) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) {
        dots[i].classList.remove('is-active'); void dots[i].offsetWidth;
        dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true');
      }
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (reduce || root.classList.contains('is-paused')) return;
      timer = setTimeout(function () { go(i + 1); }, interval);
    }
    var pv = root.querySelector('[data-jm-prev]'), nx = root.querySelector('[data-jm-next]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); restart(); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
    root.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) { root.classList.add('is-paused'); go(idx); }
    });
    go(0);
  }

  function initRail(root) {
    if (root.dataset.jmReady) return;
    root.dataset.jmReady = '1';
    var track = root.querySelector('.jm-rail__track');
    var prev = root.querySelector('[data-jm-prev]');
    var next = root.querySelector('[data-jm-next]');
    if (!track) return;
    function step() { var c = track.querySelector('.jm-card'); return c ? c.offsetWidth + 24 : track.clientWidth * .8; }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; });
    window.addEventListener('mouseup', function () { if (down) { down = false; track.classList.remove('is-dragging'); } });
    track.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = sl - dx;
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.jm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  var parallax = [];
  function initParallax() {
    parallax = Array.prototype.slice.call(document.querySelectorAll('img.jm-bleed__img'));
  }
  function onScroll() {
    if (reduce) return;
    var vh = window.innerHeight;
    parallax.forEach(function (img) {
      var r = img.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translate3d(0,' + (p * -6) + '%,0)';
    });
  }

  function init(scope) {
    setHeaderHeight();
    (scope || document).querySelectorAll('[data-jm-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-jm-rail]').forEach(initRail);
    initReveal(scope);
    initParallax();
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();